export default "__VITE_ASSET__uBZgJTlx__"